import { 
  apiGetSignals,
  apiGetSignalById,
  apiCreateSignal,
  apiUpdateSignal,
  apiGetSignalsFiltered,
  apiGetSignalsSorted,
} from "@/Groups/Signals/private/api/signalsApi";

// -------------------------------
// ОСНОВНЫЕ ДАННЫЕ
// -------------------------------
export const initSignals = async ({ dispatch }) => {
  await dispatch("getSignals");
};

export const getSignals = async ({ commit }) => {
  commit("TOGGLE_LOADING_FLAG", true);
  commit("SET_ACTIVE_SORT", null);
  
  try {
    const data = await apiGetSignals();
    commit("CLEAR_DATA");
    commit("SET_DATA", data.results);
    commit("SET_NEW_LINK", data.next);
    commit("SORT_SIGNALS");
    commit("SET_READY_FLAG");
  } catch (err) {
    console.error("Ошибка при получении сигналов:", err);
    throw err;
  } finally {
    commit("TOGGLE_LOADING_FLAG", false);
  }
};

export const loadNextSignals = async ({ commit, state }) => {
  if (!state.next) return;

  commit("TOGGLE_LOADING_NEW_PAGE_FLAG", true);
  try {
    let data;
    if (state.activeSort) {
      data = await apiGetSignalsSorted(
        state.activeSort.key,
        state.activeSort.direction,
        state.next
      );
    } else if (state.activeFilter) {
      data = await apiGetSignalsFiltered(state.activeFilter, state.next);
    } else {
      data = await apiGetSignals(state.next);
    }

    commit("SET_DATA", data.results);
    commit("SET_NEW_LINK", data.next);

    if (!state.activeSort) {
      commit("SORT_SIGNALS");
    }
  } catch (err) {
    console.error("Ошибка получения следующей страницы:", err);
    throw err;
  } finally {
    commit("TOGGLE_LOADING_NEW_PAGE_FLAG", false);
  }
};

// -------------------------------
// ОТДЕЛЬНЫЕ СИГНАЛЫ
// -------------------------------
export const getAndAddTheSignal = async ({ commit }, id) => {
  try {
    const data = await apiGetSignalById(id);
    commit("SET_NEW_SIGNAL", data);
    return data;
  } catch (err) {
    console.error("Ошибка при получении сигнала:", err);
    throw err;
  }
};

export const addSignal = async ({ commit }, formData) => {
  commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", true);
  try {
    const data = await apiCreateSignal(formData);
    commit("SET_NEW_SIGNAL", data);
    commit("SORT_SIGNALS");
    commit("UPDATE_DRAFT_FORM", null);
    return data;
  } catch (err) {
    console.error("Ошибка addSignal:", err);
    throw err;
  } finally {
    commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", false);
  }
};

export const changeSignal = async ({ commit, state }, formData) => {
  commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", true);
  try {
    const data = await apiUpdateSignal(state.idEditSignal, formData);
    commit("UPDATE_SIGNAL", data);
    return data;
  } catch (err) {
    console.error("Ошибка changeSignal:", err);
    throw err;
  } finally {
    commit("TOGGLE_SIGNAL_SEND_LOADING_FLAG", false);
  }
};

export const updateData = async ({ commit }, data) => {
  commit("UPDATE_DATA", data);
};

export const refreshData = async ({ commit }, data) => {
  commit("REFRESH_DATA", data);
};